import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'styled-components';
import { LayoutBox } from '../Layout/LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTextBreeze = styled(LayoutBox).withConfig({
  displayName: "TextBreeze__StyledTextBreeze",
  componentId: "p14p0z-0"
})(["@supports (-webkit-text-fill-color:transparent){background-clip:text;background-image:var(--layout-lib-gradient-breeze-dark);-webkit-text-fill-color:transparent;}"]);
export const TextBreeze = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledTextBreeze, Object.assign({}, rest, {
    color: "breezeBrand",
    children: children
  }));
};